import {
  RateGroupType,
  ShippingRateDto,
  ShippingRateFe,
  ShippingRateGroupFe,
} from "@intelligems/ig-types";

import { VariationFe } from "../../../../../../types/schemas/variations";
import {
  DualErrorType,
  SingleErrorType,
  TierErrorType,
} from "../../../../../../types/shipping";

export const isSaveDisabled = (
  selectedRateType: RateGroupType,
  errorState: SingleErrorType[] | TierErrorType[] | DualErrorType[],
  variation: VariationFe,
  customTestDesc: string | null | undefined
) => {
  if (selectedRateType === "flatRate" || selectedRateType === "thresholdOnly") {
    return (
      (errorState as SingleErrorType[]).some((state) => state.error) ||
      variation.shippingRateGroups!.some(
        (group) => !group.rates[0].name || !group.rates[0].amount
      )
    );
  } else if (selectedRateType === "flatRateWithThreshold") {
    return (
      (errorState as SingleErrorType[]).some((state) => state.error) ||
      variation.shippingRateGroups!.some((group) =>
        group.rates.some((rate) => !rate.name)
      ) ||
      variation.shippingRateGroups!.some((group) =>
        group.rates.some((rate) => !rate.amount)
      )
    );
  } else if (selectedRateType === "tieredByPriceOrWeight") {
    return (
      (errorState as TierErrorType[]).some(
        (state) => state.maxError || state.minError || state.nameError
      ) ||
      variation.shippingRateGroups!.some(
        (group) => !group.rates[0].name || !group.rates[0].amount
      )
    );
  } else if (selectedRateType === "custom") {
    return !customTestDesc;
  } else return false;
};

const formatCondition = (
  condition: string | number | null,
  type: "min" | "max"
): number => {
  if (condition === null || condition === undefined) {
    return type === "min" ? 0 : 99999999;
  }
  if (typeof condition === "string") {
    return parseFloat(condition);
  }
  return condition;
};

export const checkOverlap = (
  interval: { min: number; max: number },
  intervals: ShippingRateGroupFe[]
) => {
  for (let i = 0; i < intervals.length; i++) {
    const formattedMax = formatCondition(
      intervals[i].rates[0]!.condition!.max!,
      "max"
    );
    const formattedMin = formatCondition(
      intervals[i].rates[0]!.condition!.min,
      "min"
    );

    if (interval.min! < formattedMax && interval.max! > formattedMin) {
      return true;
    }
    i++;
  }
  return false;
};

export const hasTierError = (errorState: TierErrorType[], index: number) => {
  return (
    errorState[index]?.maxError ||
    errorState[index]?.minError ||
    errorState[index]?.nameError
  );
};
export const orderFlatThresholdRate = (
  rateA: ShippingRateFe,
  rateB: ShippingRateFe
) => {
  if (rateA.rateType === "threshold") return 1;
  return -1;
};
